import GallectionSearchViewContainer, {
  OwnProps,
} from './GallectionSearchView.container';
import GallectionSearchView from './GallectionSearchView';

export default GallectionSearchViewContainer(
  GallectionSearchView
) as React.ComponentClass<OwnProps>;
